import getMessage from 'src/background/utils/i18n.utils';
import React, { useState } from 'react';
import { Separator } from 'src/common-ui/separator/separator.component';
import { SVGIcon } from 'src/common-ui/svg-icon/svg-icon.component';
export const MenuItemComponent = ({ menuItem, isLast, handleMenuItemClick, }) => {
    const [hovered, setHovered] = useState(false);
    return (React.createElement("div", { className: "menu-item-container", onMouseOver: () => setHovered(true), onMouseLeave: () => setHovered(false) },
        React.createElement("div", { "data-testid": 'menu-settings-button-' + menuItem.icon, className: "menu-item", onClick: () => handleMenuItemClick(menuItem) },
            React.createElement(SVGIcon, { icon: menuItem.icon, className: "icon", forceHover: hovered }),
            React.createElement("div", { className: "menu-label" }, getMessage(menuItem.label)),
            React.createElement("div", { className: "divider" }),
            menuItem.rightPanel && React.createElement(menuItem.rightPanel, null),
            menuItem.experimental && (React.createElement("div", { className: "experimental" }, getMessage('common_experimental')))),
        !isLast && React.createElement(Separator, { type: 'horizontal' })));
};
